<template>
  <div>
    <el-dialog
      :visible.sync="newDialog"
      center
      :close-on-click-modal="true"
      custom-class="dialog_normal2"
      :append-to-body="true"
      @close="chasPrivilegeDialog"
    >
      <div class="detail_cont">
        <h3 class="AddcompaniesTitle">
          {{ $t("DataManagement.OnlineMatching") }}
        </h3>
        <h4
          class="textdecoration cuspoint flex_center_end font1290C9 margin-bottom10"
        >
          <span
            class="textdecoration font1290C9 cuspoint"
            @click="showReportIndex = true"
            >{{ $t("DataManagement.Identifythecompanywithmanualcheck") }}</span
          >
        </h4>
        <div class="flex_center_bettwen">
          <div class="head_search flex_center" ref="input">
            <div
              class="country-dropdown"
              @click.stop="isCountryShow = !isCountryShow"
            >
              <span class="select-country-con">
                <template
                  v-if="
                    selectCountryObj.countryCode == null ||
                    selectCountryObj.countryCode == '' ||
                    selectCountryObj.countryCode == 'undefined'
                  "
                >
                  <span class="country-placeholder">{{
                    $t("DataManagement.Selectcountry")
                  }}</span>
                </template>
                <template v-else>
                  <img
                    :src="selectCountryObj.urlBanner"
                    class="select-country-img"
                  />
                  <span class="select-country-name">{{
                    selectCountryObj.nameEn
                  }}</span>
                </template>
                <i
                  class="iconfont icon-jiantouxia"
                  :class="{ 'country-arrow': isCountryShow }"
                ></i>
              </span>
            </div>

            <!-- 下拉菜单内容 -->
            <div
              ref="countryRef"
              class="country-popper"
              :class="{ 'country-show-popper': isCountryShow }"
            >
              <div class="country-popper-arrow"></div>
              <div class="country-popper-con">
                <div class="state-con">
                  <div
                    class="country-state-item"
                    :class="{ activeState: selectStateIndex == index }"
                    v-for="(item, index) in stateList"
                    :key="index"
                    @click="onChangeState(index)"
                  >
                    <span class="country-name">{{
                      item.continent.enName
                    }}</span>
                    <span class="country-countryCount">{{
                      item.continent.countryNumStr
                    }}</span>
                  </div>
                </div>
                <div class="state-country-con">
                  <div
                    class="state-country-item"
                    v-for="(item, index) in stateCountryList"
                    :key="index"
                    :class="{
                      activeCountry:
                        selectCountryObj.countryCode == item.countryCode,
                    }"
                    @click="selectCountryObjFn(item)"
                  >
                    <div class="state-country-item-con">
                      <img :src="item.urlBanner" />
                      <div class="state-country-info">
                        <div class="state-country-name">{{ item.nameEn }}</div>
                        <div class="state-country-companyCount">
                          {{ item.companyNumStr }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- 搜索 -->
            <div class="search_right flex_center">
              <input
                type="text"
                :placeholder="$t('DataManagement.Entercompanyname')"
                v-model="searchName"
                class="search_input"
                @keyup.enter="EnterSearch()"
              />
            </div>
          </div>
        </div>
        <div class="FilterCompanyBg">
          <div class="flex_center_bettwen">
            <div class="cas_panel cas_loc">
              <el-cascader
                ref="Industry"
                clearable
                v-model="industryCheckList"
                :options="industryList"
                filterable
                :props="optionsProps"
                :popper-append-to-body="true"
                @change="menuCheck('Industry')"
                :placeholder="$t('DataManagement.Selectindustry')"
                popper-class="cas_loc_boxindystry"
              >
                <template slot-scope="{ data }">
                  <el-tooltip
                    class=""
                    effect="dark"
                    :content="data.name"
                    placement="top"
                  >
                    <span class="casca_lab casca_labtwo">{{ data.name }}</span>
                  </el-tooltip>
                </template>
              </el-cascader>
            </div>
            <div class="cas_panel cas_loc">
              <el-select
                style="width: 100%"
                @change="menuCheck('Industry')"
                clearable
                v-model="companyTypeCheck"
                filterable
                :popper-append-to-body="false"
                :placeholder="$t('DataManagement.Selectcompanytype')"
              >
                <el-option
                  v-for="(item, index) in companyTypeList"
                  :key="index"
                  :label="item.name"
                  :value="item.value"
                >
                  <div class="flex-between-center">
                    <span class="select-name">{{ item.name }}</span>
                  </div>
                </el-option>
              </el-select>
            </div>
            <div class="cas_panel cas_loc">
              <el-select
                style="width: 100%"
                @change="menuCheck('Industry')"
                clearable
                v-model="companySizeCheck"
                filterable
                :popper-append-to-body="false"
                :placeholder="$t('DataManagement.Selectcompanysize')"
              >
                <el-option
                  v-for="(item, index) in companySizeList"
                  :key="index"
                  :label="item.name"
                  :value="item.value"
                >
                  <div class="flex-between-center">
                    <span class="select-name">{{ item.name }}</span>
                  </div>
                </el-option>
              </el-select>
            </div>
          </div>
          <div class="flex_center_bettwen">
            <div class="cas_panel cas_loc margin-bottom0">
              <el-select
                style="width: 100%"
                @change="menuCheck('Industry')"
                clearable
                v-model="companyStatusCheck"
                filterable
                :popper-append-to-body="false"
                :placeholder="$t('DataManagement.Selectcompanystatus')"
              >
                <el-option
                  v-for="(item, index) in companyStatusList"
                  :key="index"
                  :label="item.name"
                  :value="item.value"
                >
                  <div class="flex-between-center">
                    <span class="select-name">{{ item.name }}</span>
                  </div>
                </el-option>
              </el-select>
            </div>
            <div class="cas_panel cas_loc margin-bottom0">
              <el-select
                style="width: 100%"
                @change="menuCheck('Industry')"
                clearable
                v-model="listedCompanyCheck"
                filterable
                :popper-append-to-body="false"
                :placeholder="$t('DataManagement.Selectlistedcompanies')"
              >
                <el-option
                  v-for="(item, index) in listedCompanyList"
                  :key="index"
                  :label="item.name"
                  :value="item.value"
                >
                  <div class="flex-between-center">
                    <span class="select-name">{{ item.name }}</span>
                  </div>
                </el-option>
              </el-select>
            </div>
            <div class="cas_panel cas_loc margin-bottom0">
              <el-select
                style="width: 100%"
                @change="menuCheck('Industry')"
                clearable
                v-model="timePeriodCheck"
                filterable
                :popper-append-to-body="false"
                :placeholder="$t('DataManagement.Selectcompanyyearsinbusiness')"
              >
                <el-option
                  v-for="(item, index) in timePeriodList"
                  :key="index"
                  :label="item.name"
                  :value="item.value"
                >
                  <div class="flex-between-center">
                    <span class="select-name">{{ item.name }}</span>
                  </div>
                </el-option>
              </el-select>
            </div>
          </div>
        </div>

        <div class="" style="position: relative; margin-top: 10px">
          <div class="table_box draggable">
            <el-table
              ref="treeTable"
              :key="refresh"
              :data="parentTable"
              empty-text="No Data"
              border
              row-key="aaa_id"
              @selection-change="handleSelectionChange"
              style="width: 100%"
              v-loading="parentTableloding"
            >
              <el-table-column type="selection" width="50"></el-table-column>

              <el-table-column
                :label="$t('DataManagement.CompanyName')"
                width="200"
                align="left"
                show-overflow-tooltip
                :resizable="false"
                class-name="company company_link "
              >
                <template slot-scope="scope">
                  <div class="line_1" style="width: 340px">
                    <img :src="scope.row.flag" />
                    <div @click="setid(scope.row)" class="tbl_company line_1">
                      {{ scope.row.company_name_en }}
                    </div>
                  </div>
                </template>
              </el-table-column>

              <el-table-column
                :label="$t('DataManagement.Country')"
                prop="company_country"
                align="left"
                show-overflow-tooltip
                :resizable="false"
              >
                <template slot-scope="scope">
                  {{ getCountry(scope.row.company_country) }}
                </template>
              </el-table-column>
              <el-table-column
                :label="$t('DataManagement.Industry')"
                prop="isic_en"
                align="left"
                show-overflow-tooltip
                :resizable="false"
              >
              </el-table-column>
              <el-table-column
                :label="$t('DataManagement.CompanyType')"
                prop="company_class_en"
                align="left"
                show-overflow-tooltip
                :resizable="false"
              >
              </el-table-column>
              <el-table-column
                :label="$t('DataManagement.CompanyStatus')"
                prop="status_en"
                align="left"
                show-overflow-tooltip
                :resizable="false"
              />

              <template slot="empty">
                <div
                  class="flex_center"
                  style="
                    justify-content: center !important;
                    height: 100%;
                    width: 100%;
                  "
                >
                  <img
                    style="height: 60%"
                    src="../../../../assets/images/noDate.png"
                    alt=""
                  />
                </div>
              </template>
            </el-table>
            <div class="page_i_box">
              <Page
                :totalFont="true"
                :total="page.total"
                :pageSize.sync="page.pageSize"
                :currentPage="page.pageNo"
                @onPageChange="onPageChangeList"
              ></Page>

              <div class="search_rsult_txt line_2">
                {{ page.pageNo }}-{{ page.pageSize }} of over
                <span
                  class="foundOverNum"
                  :style="{ color: $store.state.app.themeColor }"
                  >&nbsp;{{ page.total | FilterNum }}&nbsp;</span
                >
                results for " {{ searchName }}"
              </div>
            </div>
            <!-- <div class="page_i_box">
                            <Page :totalFont="true" :total="page.total" @onPageChange="onPageChange" @currtentPageChange="currtentPageChange"></Page>
                            <div class="search_rsult_txt line_2">{{ page.pageNo }}-{{ page.pageSize }} of over {{ page.total | FilterNum }} results for "{{ searchName }}"</div>
                        </div> -->
          </div>
        </div>
        <div
          class="dialog-footer foot_content flex_center margin-top20"
          style="justify-content: center !important"
        >
          <!-- <el-button
            class="btn_export btn_exporthui"
            @click="chasPrivilegeDialog"
          >
            <i class="iconfont icon-quxiao"></i>{{ $t("DataManagement.Cancel") }}
          </el-button> -->
          <el-button
            :class="
              CompapareList.length != 1
                ? 'btn_export btn_exporthui'
                : 'btn_export'
            "
            :disabled="CompapareList.length != 1"
            @click="ConfirmAdd"
          >
            <i class="iconfont icon-queren"></i
            >{{ $t("DataManagement.Confirm") }}
          </el-button>
        </div>
      </div>
    </el-dialog>
    <ReLogin :reLoginPop="reLoginVis"></ReLogin>
    <Deepassment
      :showReport="showReportIndex"
      @closeReportDialog="closeDialog3($event)"
    ></Deepassment>
  </div>
</template>
<script>
import { searchCompany, userCompanyAction } from "@/api/searchApi.js";

import { mixins1 } from "@/mixins/index";

import ReLogin from "@/components/ReLogin.vue";
import Deepassment from "./deepassment/index.vue";
import Page from "@/components/page/index.vue";
import { getoptions } from "@/api/companyApi";

export default {
  mixins: [mixins1],
  // components: { Page },
  components: {
    ReLogin,
    Deepassment,
    Page,
  },
  watch: {
    addDialog: {
      handler(newVal, oldVal) {
        if (newVal) {
          this.page.pageNo = 1;
          this.industryCheck = "";
          this.companyTypeCheck = "";
          this.companySizeCheck = "";
          this.companyStatusCheck = "";
          this.industryCheckList = [];
          this.listedCompanyCheck = "";
          this.timePeriodCheck = "";
          this.CompapareList = [];
          this.searchName = this.CompanyName;
          this.getConditions();

          this.searchCompanyByName();
          this.handleSelectionChange([]);
          if (this.$refs.treeTable) {
            this.$refs.treeTable.clearSelection();
          }
        }

        // 这里可以进行一些逻辑处理或者触发其他操作
      },

      deep: true, // 深度监听，可以监听对象内部属性的变化
      immediate: true, // 立即执行一次handler函数，即使columns没有变化
    },
  },
  computed: {
    newDialog: {
      get() {
        return this.addDialog;
      },
      set() {},
    },
  },
  props: {
    addDialog: {
      type: Boolean,
    },
    CompanyName: {
      type: String,
    },
    ComID: {
      type: Number,
    },
  },

  data() {
    return {
      reLoginVis: false,

      optionsProps: {
        label: "name", //名称展示
        value: "value", //值展示
        expandTrigger: "click", //次级菜单的展开方式
      },
      countryVal: "",

      page: {
        pageNo: 1,
        pageSize: 10,
        total: 0,
      },

      //国家分类
      tabCountryList: [],
      productloding: false,
      percentageerr: false,
      showReportIndex: false,
      cascInptIndustry: "",
      industryCheckList: [],
      CompapareList: [],
      countryCode1: "",
      countryCode: "",
      countryName: "", //选中国家
      countryImg: "", //选中国家的国旗
      tabActiveName: "", //选择的区域
      isNotice: true, //通知高亮
      searchName: "",
      parentTable: [],
      expands: [],
      branchflag: "",
      refresh: 0,
      parentTableloding: false,
      industryCheck: "",
      companyTypeCheck: "",
      companySizeCheck: "",
      companyStatusCheck: "",
      listedCompanyCheck: "",
      timePeriodCheck: "",
      timePeriodList: [],
      listedCompanyList: [],
      companyStatusList: [],
      companySizeList: [],
      companyTypeList: [],
      industryPreList: [],
      industryList: [],

      isCountryShow: false,
      selectCountryObj: {
        countryCode: "",
      },
      stateList: [],
      stateCountryList: [],
      selectStateIndex: 0,
    };
  },

  created() {
    this.getAllCountry();
  },

  mounted() {
    document.addEventListener("click", this.handleClickOutside);
    this.getCountryList();
  },
  beforeDestroy() {
    document.removeEventListener("click", this.handleClickOutside);
  },

  methods: {
    // 切换洲的选择
    onChangeState(index) {
      this.selectStateIndex = index;
      this.stateCountryList = this.stateList[index].countryList;
    },

    // 选择国家
    selectCountryObjFn(ite) {
      this.selectCountryObj = ite;
      this.countryCode = ite.countryCode;
      let newscountry = this.tabCountryList[0].countryList;
      newscountry.map((item) => {
        if (item.countryCode == ite.countryCode) {
          this.countryCode1 = item.dowjonesCountrycode;
        }
      });
      this.isCountryShow = false;
    },

    // 点击外部关闭下拉菜单
    handleClickOutside(event) {
      let countryRef = this.$refs.countryRef;
      if (countryRef && !countryRef.contains(event.target)) {
        this.isCountryShow = false;
      }
    },

    // 初始化国家数据
    async getCountryList() {
      if (localStorage.getItem("countryList")) {
        this.setCountryImg();
        this.tabCountryList = JSON.parse(localStorage.getItem("countryList"));
      } else {
        let res = await getCountryCollection();
        if (res && res.code) {
          this.$store.state.countryImgList = JSON.parse(
            localStorage.getItem("countryList"),
          );
          localStorage.setItem("countryList", JSON.stringify(res.data.rows));

          this.setCountryImg();
          this.tabCountryList = JSON.parse(localStorage.getItem("countryList"));
        }
      }
    },

    // 设置国家旗帜图片
    setCountryImg() {
      this.stateList = JSON.parse(localStorage.getItem("countryList"));
      this.stateList.map((item) => {
        item.countryList.map((itemC) => {
          if (itemC.urlBanner == null) {
            itemC.urlBanner = require("../../../../../static/imagev2/zanwutupian.png");
          } else {
            let getImageUrlPath = itemC.urlBanner.split("/static")[1];
            itemC.urlBanner = require("../../../../../static" +
              getImageUrlPath);
          }
        });
      });

      this.stateCountryList = this.stateList[0].countryList;
      // 信息参数不为空时赋值
      if (
        this.countryCode != "" &&
        this.countryCode != null &&
        this.countryCode != "undefined"
      ) {
        if (this.$route.meta.title == "NewsList") {
          this.selectCountryObj = this.stateCountryList.filter(
            (item) => item.countryCode == this.countryCode,
          )[0];
        } else {
          let filterData = this.sanctionList.filter(
            (item) => item.dictDataCode == this.countryCode,
          )[0];
          this.selectSanctionObj = {
            sanctionCode: filterData.dictDataCode,
            sanctionName: filterData.dictDataName,
          };
        }
      }
    },

    EnterSearch() {
      this.page.pageNo = 1;
      this.industryCheck = "";
      this.companyTypeCheck = "";
      this.companySizeCheck = "";
      this.companyStatusCheck = "";
      this.companyStatusCheck = "";
      this.timePeriodCheck = "";
      this.industryCheckList = [];
      this.listedCompanyCheck = "";
      if (this.$refs.treeTable) {
        this.$refs.treeTable.clearSelection();
      }
      this.CompapareList = [];

      this.searchCompanyByName();
      this.getConditions();
    },
    menuCheck(value) {
      this.page.pageNo = 1;
      if (this.$refs.treeTable) {
        this.$refs.treeTable.clearSelection();
      }
      this.CompapareList = [];
      this.searchCompanyByName();
      this.getConditions();
    },
    async getConditions() {
      const params = {
        company_name: this.searchName,
        company_country: this.countryCode,
        industry_en: this.industryCheckList[1],
        company_class_code: this.companyTypeCheck,
        scale_code: this.companySizeCheck,
        reg_status: this.companyStatusCheck,
        listing_status_code: this.listedCompanyCheck,
        years: this.timePeriodCheck,
      };
      await getoptions(params).then((res) => {
        if (res && res.code) {
          this.countryList = res.data.geographicalLocation;
          this.industryList = res.data.industry;
          this.industryPreList = res.data.industry;

          this.companyTypeList = res.data.companyTypeList;

          // this.companyTypeList=
          this.companySizeList = res.data.companySizeList;
          this.companyStatusList = res.data.regStatus;
          this.listedCompanyList = res.data.listingStatusList;
          this.timePeriodList = res.data.yearsOfEstablishment;
        }
      });
    },
    ConfirmAdd() {
      userCompanyAction({
        id: this.ComID,
        aaaid: this.CompapareList[0].aaa_id,
      }).then((res) => {
        if (res.code == 200) {
          this.$emit("closeAdd", false);
          this.CompapareList = [];
          this.$parent.getgetUserActionLogPage();
          this.$message({
            message: res.msg,
            center: true,
            type: "success",
          });
        } else {
          this.$message({
            message: res.msg,
            center: true,
            type: "error",
          });
        }
      });
    },
    closeDialog3(value) {
      this.showReportIndex = value;
    },
    chasPrivilegeDialog() {
      this.$emit("closeAdd", false);
    },
    async getAllCountry() {
      let countryCode = (this.countryCode = this.$route.query.companyCountry
        ? this.$route.query.companyCountry
        : "");
      // localStorage.setItem('countryList',JSON.stringify(countryImgList))
      // 处理缓存问题
      if (JSON.parse(localStorage.getItem("countryList"))) {
        this.tabCountryList = JSON.parse(localStorage.getItem("countryList"));
        let list = this.tabCountryList;
        list.forEach((item, index) => {
          item.countryList.forEach((it) => {
            let countryImg = "";
            if (it.urlBanner == null) {
              countryImg = require("../../../../../static/imagev2/zanwutupian.png");
            } else {
              countryImg = it.urlBanner.split("./../../../static")[1];
            }
            // let flag = require('../../static' + countryImg);
            let flag = "";
            try {
              flag = require("../../../../../static" + countryImg);
            } catch (error) {
              countryImg = "../../../../../static/imagev2/zanwutupian.png";
              // 提供一个默认值或者其他处理方式
              flag = require("../../../../../static" + countryImg);
            }
            it.urlBanner = flag;
            if (countryCode && it.countryCode == countryCode) {
              this.countryName = it.nameEn;
              this.countryImg = it.urlBanner;
            }
          });
        });
      }
    },
    onPageChangeList({ page, size }) {
      this.page.pageSize = size;
      this.page.pageNo = page;
      if (this.$refs.treeTable) {
        this.$refs.treeTable.clearSelection();
      }
      this.CompapareList = [];
      this.searchCompanyByName();
    },
    currtentPageChange(pageSize) {
      this.page.pageSize = pageSize;
      if (this.$refs.treeTable) {
        this.$refs.treeTable.clearSelection();
      }
      this.CompapareList = [];
      this.searchCompanyByName();
    },
    // 全选
    handleSelectionChange(selection) {
      this.CompapareList = selection;
    },

    // 点击跳转
    setid(row) {
      sessionStorage.setItem("company", JSON.stringify(row));
      let newscountry = JSON.parse(localStorage.getItem("countryList"))[0]
        .countryList;
      let companyCountryEn = "";
      newscountry.map((item) => {
        if (item.countryCode == row.company_country) {
          companyCountryEn = item.dowjonesCountrycode;
        }
      });
      let routeData = this.$router.resolve({
        path:
          "/index/company/details/" +
          row.aaa_id +
          "/background/snapshot?id3a=" +
          row.aaa_id +
          "&companyCountry=" +
          row.company_country +
          "&companyCountryEn=" +
          companyCountryEn +
          "&keword=" +
          this.$route.query.keword,
      });

      window.open(routeData.href, "_blank");
    },
    //分页

    //清除选择的国家
    clearCountry() {
      this.countryImg = "";
      this.countryCode = "";
      this.countryCode1 = "";
    },

    //下拉选择国家
    selectCountry(val) {
      let countryImg = this.getCountryImgUrl(val);
      let flag = require("../../../../../static" + countryImg);
      this.countryImg = flag;
      this.countryCode = val;

      let newscountry = this.tabCountryList[0].countryList;
      newscountry.map((item) => {
        if (item.countryCode == val) {
          this.countryCode1 = item.dowjonesCountrycode;
        }
      });
    },
    // 选中国家
    //搜索公司
    async searchCompanyByName() {
      this.CompapareList = [];
      this.parentTableloding = true;
      let params = {
        company_name: this.searchName,
        company_country: this.countryCode,
        page: this.page.pageNo,
        pageSize: this.page.pageSize,
        industry_en: this.industryCheckList[1],
        company_class_code: this.companyTypeCheck,
        scale_code: this.companySizeCheck,
        reg_status: this.companyStatusCheck,
        listing_status_code: this.listedCompanyCheck,
        years: this.timePeriodCheck,
      };
      let res = await searchCompany(params);
      this.parentTable = [];

      if (res && res.code) {
        this.page.total = res.data.total;
        let list = (this.parentTable = res.data.rows);
        //查找本地图片
        list = list.map((item, index) => {
          let countryImg = this.getCountryImgUrl(item.company_country);
          let flag = require("../../../../../static" + countryImg);
          this.parentTable[index].flag = flag;
          this.refresh++;
        });
        this.parentTableloding = false;
      } else {
        this.loading = false;
        // this.addPopIndex2=true
        this.parentTable = [];
        this.parentTableloding = false;
        if (res.ret == "1002") {
          this.ret = true;
        } else {
          this.ret = false;
        }
      }
      // }
    },
    //获取国家

    //add compant弹框
    Add() {
      this.parentTable = [];
      this.countryImg = "";
      this.countryVal = "";
      this.searchName = "";
    },
    // 确定提交
    async submitAdd() {},
  },
};
</script>
<style scoped lang="less">
.country_img {
  position: absolute;
  top: 0.2857142857142857rem;
  left: 0.2857142857142857rem;
  z-index: 8;
}

.country_img img {
  width: 3.2857142857142856rem;
  height: 2.2857142857142856rem;
}

.el-select,
.el-autocomplete {
  width: 100%;
}

.cop_add {
  // width: 18.857142857142858rem;
  // width: 25%;
  height: 2.857142857142857rem;
  cursor: pointer;
}

/* 搜索 */
.head_search {
  position: relative;
  width: 85%;
  // width: 67.85714285714286rem;
  height: 54px;
  background: #ffffff;
  border-radius: 10px;
  border: 1px solid #cccccc;
  color: #022955;
  // margin: auto;
  // margin-left: 4.428571428571429rem;
}

.search_right {
  flex: 1;
  position: relative;
}

.search_input {
  width: 100%;
  word-wrap: break-word;
  line-height: 2.142857142857143rem;
  outline: none;
  border: none;
  // padding: 0 1.4285714285714286rem;
  font-size: 1.14285714rem;
}

.search_btn {
  width: 2.857142857142857rem;
  height: 3.857142857142857rem;
  cursor: pointer;
}

.search_btn img {
  width: 1.7142857142857142rem;
}

/* 选择下拉 */
.search_left {
  width: 17.142857142857142rem;
  height: 100%;
  position: relative;
  display: flex;
  align-items: center;
}

.search_left::after {
  content: "";
  position: absolute;
  right: 0;
  top: 10px;
  width: 1px;
  height: 36px;
  background-color: #e7eaed;
}

.search_left /deep/ .el-input__inner {
  border: none;
  font-size: 16px;
}

// /deep/ .el-input__inner {
//   padding-right: 0rem !important;
// }

.country_flag {
  display: flex;
  align-items: center;
}

.country_flag_img {
  width: 2.5714285714285716rem;
  height: 1.5714285714285714rem;
  margin: 1.0714285714285714rem 0.14285714285714285rem 1.0714285714285714rem
    1.0714285714285714rem;
  box-shadow: 0rem 0.07142857142857142rem 0.14285714285714285rem 0rem
    rgba(0, 0, 0, 0.2);
}

.sel_value {
  width: 4.571428571428571rem;
  font-size: 1rem;
  word-break: break-all;
}

.search_left .el-select {
  position: absolute;
  top: 0;
  width: 17.428571428571427rem;
}

.search_left /deep/ .el-select .el-input__inner {
  background-color: transparent;
  height: 54px;
  /* opacity: 0; */
  font-size: 14px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.search_left.on /deep/ .el-select .el-input__inner {
  padding-left: 4.285714285714286rem;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.head_pro_cas /deep/ .el-input__inner::placeholder,
.search_left /deep/ .el-select .el-input__inner::placeholder {
  color: #666666;
  /* 红色 */
}

.head_pro_cas /deep/ .el-icon-arrow-down:before,
.search_left /deep/ .el-select .el-icon-arrow-up:before {
  color: #8497ab !important;
  // font-weight: 600;
}

.sel_place {
  width: 100%;
  line-height: 3.7142857142857144rem;
  padding-left: 1.4285714285714286rem;
  display: inline-block;
  font-size: 1rem;
}

.el-select-dropdown__wrap {
  max-height: 26.785714285714285rem !important;
}

/* .el-cascader__dropdown{
z-index: 9999999 !important;
} */
.el-select-dropdown__list {
  padding: 0.7142857142857143rem 0 !important;
}

.search_sel_container {
  width: 85.71428571428571rem;
}

.search_sel_container /deep/ .el-tabs--left .el-tabs__nav-wrap.is-left {
  // width: 17.142857142857142rem;
}

.search_sel_container /deep/ .el-tabs--left .el-tabs__nav-wrap.is-left::after {
  width: 0.07142857142857142rem;
  background-color: #eee;
}

.head_swi_keyword {
  position: relative;
}

.head_swi_keyword .el-switch,
.head_login .el-switch {
  height: 2.4285714285714284rem;
  line-height: 2.4285714285714284rem;
}

.head_swi_keyword /deep/ .el-switch__core,
.head_login /deep/ .el-switch__core {
  width: 7rem !important;
  height: 2.4285714285714284rem;
  background: #006a9a;
  box-shadow: inset 0rem 0.07142857142857142rem 0.14285714285714285rem 0rem
    #054562;
  border-radius: 1.2142857142857142rem;
  border: none;
}

.head_swi_keyword /deep/ .el-switch__core {
  width: 7.142857142857143rem !important;
}

.head_swi_keyword /deep/ .el-switch.is-checked .el-switch__core {
  background: #ff7600;
  box-shadow: inset 0rem 0.07142857142857142rem 0.14285714285714285rem 0rem
    #aa4f00;
}

.head_swi_keyword /deep/ .el-switch__core:after,
.head_login /deep/ .el-switch__core:after {
  top: 0.21428571428571427rem;
  left: 0.21428571428571427rem;
  width: 2rem;
  height: 2rem;
  background: #ffffff;
}

.head_swi_keyword /deep/ .el-switch.is-checked .el-switch__core::after {
  left: 6.142857142857143rem;
}

.search_sel_container /deep/ .el-tabs__active-bar {
  display: none;
}

.search_sel_container .right {
  width: 68.5rem;
  display: flex;
  flex-wrap: wrap;
  flex: 1;
  max-height: 24.285714285714285rem;
  align-content: flex-start;
  margin-right: 0.07142857142857142rem;
  padding: 0 0.571428571428571rem;
  overflow: auto;
}

.search_sel_container /deep/ .el-tabs--left .el-tabs__item.is-left {
  height: 3rem;
  display: flex;
  align-items: center;
}

.search_sel_container /deep/ .el-tabs__item.is-left.is-active {
  background: #f5f5f5;
}

.el-select-dropdown__item:hover {
  background: #f5f5f5;
}

.search_sel_container /deep/ .el-tabs__item:hover {
  color: #1290c9;
  font-weight: normal;
}

.search_sel_container .left_txt {
  font-size: 14px;
  margin-right: 10px;
}

.search_sel_container .right .el-select-dropdown__item {
  width: 15.857142857142858rem;
  height: 4rem;
  padding: 0 0.7142857142857143rem;
  margin: 0.3542857142857143rem 0.35714285714285715rem;
  border: 0.07142857142857142rem solid #fff;
  background: #f5f5f5;
}

.search_sel_container .right /deep/ .el-select-dropdown__item.selected,
.search_sel_container .right /deep/ .el-select-dropdown__item.hover {
  background: #f5f5f5;
  /* border-radius: 1rem; */
  border: 1px solid #1290c9;
}

.search_sel_container .right /deep/ .el-select-dropdown__item.selected {
  color: #022955;
  font-weight: normal;
}

.right_item {
  height: 100%;
  width: 100%;
}

.search_sel_container .right .img {
  width: 3.857142857142857rem;
  height: 100%;
  margin-right: 0.35714285714285715rem;
}

.search_sel_container .right .rBox {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.search_sel_container .right .rBox .coun_title {
  font-size: 1.1428571428571428rem;
  line-height: 1;
  margin-bottom: 0.2857142857142857rem;
  max-width: 10rem;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

// .table_box /deep/ .el-table__empty-block .el-table__empty-text {
//   width: auto;
//   /* justify-content: flex-start !important; */
//   height: 470px;
//   overflow: auto;
// }
.table_box {
  width: auto;
  /* justify-content: flex-start !important; */

  overflow: auto;
}
::v-deep .el-table {
  height: 470px;
  overflow: auto;
}

.list-title {
  width: 25%;
}

.CompanyNameActive {
  font-size: 1.2857142857142858rem;
  color: #1290c9;
  text-decoration-line: underline;
}

// .el-select /deep/ .el-input__suffix {
//   right: 1rem !important;
// }

.content {
  padding: 0rem;
  margin: 0rem !important;
}

.flex_center {
  justify-content: flex-start;
}

.foot_content {
  gap: 40px;
}

.item_active {
  background: #f2f5f9;
  height: 10rem !important;
  position: relative;
}

.Deletepostion {
  position: absolute;
  top: 0.7142857142857143rem;
  right: 0.7142857142857143rem;
}

.Deletepostionleft {
  position: absolute;
  top: 0rem;
  left: 0.7142857142857143rem;
  width: 14.285714285714286rem;
  height: 2.857142857142857rem;
  background: #a6b7c9;
  border-radius: 0rem 0rem 1.4285714285714286rem 0rem;
  font-size: 1.2857142857142858rem;
  color: #ffffff;
  line-height: 2.857142857142857rem;
  display: flex;
  align-items: center;
}

.FilterCompanyBg .cas_panel {
  width: 32%;
}

.FilterCompanyBg /deep/ .el-input__inner,
.FilterCompanyBg /deep/ .el-cascader .el-input .el-input__inner:focus {
  height: 50px !important;
  border-radius: 10px;
}
.FilterCompanyBg {
  padding: 20px;
  background: #f5f5f5;
  border-radius: 6px;
  margin-top: 10px;
}
.FilterCompanyBg /deep/ .el-cascader .el-input__icon {
  font-size: 18px;
  color: #1a2332;
}

.AddcompaniesTitle {
  margin-bottom: 20px !important;
}
.el-button {
  height: 60px;
  min-width: 210px;
  margin-left: 0px;
}
::v-deep .el-dialog--center .el-dialog__body {
  padding: 30px 20px;
}

// 国家start
.country-dropdown,
.trade-dropdown {
  position: relative;
  width: 210px;
  min-width: 210px;
  border-radius: 27px 0 0 27px;
  margin-right: 10px;
}

.country-dropdown::after,
.trade-dropdown::after {
  content: "";
  position: absolute;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
  width: 1px;
  height: 30px;
  background: #dddddd;
}

.select-country-con {
  display: flex;
  align-items: center;
  width: 100%;
  height: 40px;
  padding: 0 14px 0 20px;
  cursor: pointer;
}

.select-country-con .country-placeholder {
  flex: 1;
  font-size: 16px;
  color: #1a2332;
}

.select-country-con i {
  font-size: 16px;
  color: #1a2332;
  transition: all 0.3s;
}

.select-country-img {
  width: 34px;
  height: 20px;
  margin-right: 6px;
  box-shadow: 0px 1px 2px 0px rgba(0, 0, 0, 0.2);
}

.select-country-name {
  flex: 1;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  margin-right: 6px;
  line-height: 20px;
  font-size: 18px;
  color: #1a2332;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.u942df .iconfont {
  font-size: 22px;
}

.country-arrow {
  transform: rotate(180deg);
}

.country-popper {
  position: absolute;
  top: 68px;
  left: 0;
  width: 1000px;
  height: 300px;
  padding: 18px 5px 0px 0;
  margin-top: 0 !important;
  background: #ffffff;
  box-shadow: 0px -8px 20px 0px rgba(10, 33, 57, 0.24);
  border-radius: 12px;
  z-index: -1;
  opacity: 0;
  pointer-events: none;
  transition: all 0.3s ease-in-out;
}

.country-show-popper {
  width: 1178px;
  height: 378px;
  opacity: 1;
  z-index: 2001;
  pointer-events: all;
  transition: all 0.3s ease-in-out;
}

.country-popper-arrow,
.country-popper-arrow::after {
  position: absolute;
  display: block;
  width: 0;
  height: 0;
  border-color: transparent;
  border-style: solid;
}

.country-popper-arrow {
  left: 90px;
  top: -12px;
  border-width: 12px;
  border-top-width: 0;
  border-bottom-color: #ffffff;
}

.country-popper-arrow::after {
  content: "";
  border-width: 12px;
  border-bottom-color: #ffffff !important;
  filter: drop-shadow(0px -8px 20px 0px rgba(10, 33, 57, 0.24)) !important;
}

.country-popper-con {
  display: flex;
  height: 100%;
  overflow: hidden;
}

.country-popper-con .state-con {
  width: 220px;
  height: calc(100% - 18px);
  flex-shrink: 0;
  border-right: 1px solid #dddddd;
  overflow: auto;
}

.country-popper-con .country-state-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  height: 42px;
  padding: 0 20px;
  cursor: pointer;
}

.country-popper-con .country-state-item:not(:last-child) {
  margin-bottom: 8px;
}

.country-popper-con .country-state-item.activeState {
  background: #f5f5f5;
}

.country-popper-con .country-state-item:hover .country-name,
.country-popper-con .country-state-item.activeState .country-name {
  color: #1290c9;
}

.country-popper-con .country-name {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;

  font-size: 16px;
  color: #1a2332;
}

.country-popper-con .country-countryCount {
  width: 30px;
  font-size: 14px;
  color: #999999;
  text-align: right;
}

.country-popper-con .state-country-con {
  width: 953px;
  display: flex;
  flex-wrap: wrap;
  flex-shrink: 0;
  align-content: flex-start;
  padding-left: 20px;
  overflow: auto;
}

.country-popper-con .state-country-item {
  width: 222px;
  height: 56px;
  padding: 8px 10px;
  margin-bottom: 10px;
  background: #f5f5f5;
  border: 1px solid #f5f5f5;
  cursor: pointer;
}

.country-popper-con .state-country-item-con {
  display: flex;
  align-items: center;
  justify-content: start;
}

.country-popper-con .state-country-item:hover,
.country-popper-con .state-country-item.activeCountry {
  border-color: #1290c9;
}

.country-popper-con .state-country-item:not(:nth-child(4n)) {
  margin-right: 10px;
}

.country-popper-con .state-country-item img {
  width: 56px;
  height: 34px;
  margin-right: 6px;
  box-shadow: 0px 1px 2px 0px rgba(0, 0, 0, 0.2);
}

.country-popper-con .state-country-info {
  flex: 1;
  overflow: hidden;
}

.country-popper-con .state-country-name {
  line-height: 20px;
  margin-bottom: 4px;
  font-size: 16px;
  color: #1a2332;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.country-popper-con .state-country-companyCount {
  font-size: 14px;
  color: #999999;
  line-height: 1;
}
// 国家end

@media screen and (max-width: 1920px) {
  ::v-deep .dialog_normal2 {
    width: 750px !important;
    height: 544px !important;
  }

  .AddcompaniesTitle {
    margin-bottom: 15px !important;
  }
  .head_search {
    height: 40px;
    width: 1005px;
    border-radius: 8px;
  }
  .search_left /deep/ .el-select .el-input__inner {
    height: 40px;
    font-size: 14px;
  }
  .search_left::after {
    top: 8px;
    height: 20px;
  }

  ::v-deep .el-table {
    height: 350px;
  }
  ::v-deep .el-table__row {
    height: 50px;
  }
  .foot_content {
    gap: 30px;
  }
  .el-button {
    height: 45px;
    min-width: 158px;
  }
  ::v-deep .el-dialog--center .el-dialog__body {
    padding: 22px 15px;
  }

  .FilterCompanyBg /deep/ .el-input__inner,
  .FilterCompanyBg /deep/ .el-cascader .el-input .el-input__inner:focus {
    height: 32px !important;
    border-radius: 8px;
  }

  // 国家start
  .country-dropdown,
  .trade-dropdown {
    width: 160px;
    min-width: 160px;
    border-radius: 20px 0 0 20px;
  }

  .country-dropdown::after,
  .trade-dropdown::after {
    height: 22px;
  }

  .select-country-con {
    padding: 0 10px 0 15px;
  }

  .select-country-con .country-placeholder {
    font-size: 14px;
  }

  .select-country-img {
    width: 22px;
    height: 14px;
    margin-right: 4px;
  }

  .select-country-name {
    margin-right: 2px;
    line-height: 16px;
    font-size: 14px;
  }

  .trade-dropdown .select-country-name {
    font-size: 14px;
  }

  .u942df .iconfont {
    font-size: 20px;
  }

  .country-popper {
    top: 46px;
    width: 750px;
    height: 200px;
    padding: 10px 3px 10px 0;
    border-radius: 4px;
  }

  .country-show-popper {
    width: 850px;
    height: 264px;
  }

  .country-popper-arrow {
    left: 35px;
    top: -6px;
    border-width: 6px;
    border-top-width: 0;
    border-bottom-color: #ffffff;
  }

  .country-popper-arrow::after {
    border-width: 8px;
  }

  .country-popper-con .state-con {
    width: 218px;
    height: 100%;
  }

  .country-popper-con .country-state-item {
    height: 40px;
    padding: 0 14px;
  }

  .country-popper-con .country-state-item:not(:last-child) {
    margin-bottom: 0px;
  }

  .country-popper-con .country-name {
    line-height: 14px;
    font-size: 14px;
  }

  .country-popper-con .country-countryCount {
    flex-shrink: 0;
    width: 20px;
    font-size: 12px;
  }

  .country-popper-con .state-country-con {
    width: 640px;
    padding-left: 10px;
  }

  .country-popper-con .state-country-item {
    width: 148px;
    height: 40px;
    padding: 4px 6px;
    margin-bottom: 6px;
  }

  .country-popper-con .state-country-item:not(:nth-child(4n)) {
    margin-right: 6px;
  }

  .country-popper-con .state-country-item img {
    width: 38px;
    height: 22px;
    margin-right: 4px;
  }

  .country-popper-con .state-country-name {
    line-height: 14px;
    margin-bottom: 2px;
    font-size: 14px;
  }

  .country-popper-con .state-country-companyCount {
    font-size: 12px;
  }
  // 国家end
}

@media screen and (max-width: 1439px) {
  ::v-deep .dialog_normal2 {
    width: 670px !important;
    height: 485px !important;
  }

  .AddcompaniesTitle {
    margin-bottom: 13px !important;
  }
  .head_search {
    height: 36px;
    width: 900px;
    border-radius: 7px;
  }
  .search_left /deep/ .el-select .el-input__inner {
    height: 36px;
    font-size: 12px;
  }
  .search_left::after {
    top: 8px;
    height: 20px;
  }

  ::v-deep .el-table {
    height: 315px;
  }
  .foot_content {
    gap: 26px;
  }
  .el-button {
    height: 40px;
    min-width: 140px;
  }
  ::v-deep .el-dialog--center .el-dialog__body {
    padding: 20px 13px;
  }
  .FilterCompanyBg /deep/ .el-input__inner,
  .FilterCompanyBg /deep/ .el-cascader .el-input .el-input__inner:focus {
    height: 34px !important;
    border-radius: 7px;
  }
}
</style>
